import React, { useEffect, useState } from "react";
import "../../assets/styles/local/TaskMain.css";
import "../../assets/styles/local/proforma.css";
import "../../assets/styles/local/contactTaskPopup.css";
import Header from "../../layouts/Header";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import { GetProforma } from "../../redux/actions/proformaAction";
import { useHistory } from "react-router-dom";
import {
  GetPOById,
  addClientPO,
  DeletePO,
  MakeInvoice,
  SendPO,
} from "../../redux/actions/proformaAction";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import MonetizationOnOutlined from "@mui/icons-material/MonetizationOnOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import Checkbox from "@mui/material/Checkbox";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import CircleIcon from "@mui/icons-material/Circle";
import TextField from "@mui/material/TextField";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { EvStation } from "@mui/icons-material";
import DeletePopUp from "../../components/Dailogs/DeletePopUp";
import Pagination from "../../components/Pagination/Pagination";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import pdfIcon from "../../assets/images/PdfIcon.svg";
import Xcircle from "../../assets/icons/x-circle.svg";
import { Spinner } from "react-bootstrap";
import grapesTemplateApi from "../../services/grapesTemplateApi";
import Loader from "../../components/Dailogs/Loader";

const Proforma = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [addWorkPopup, setAddWorkPopup] = useState(false);
  const [itemPopup, setItemPopup] = useState(false);
  const [emailPopup, setEmailPopup] = useState(false);
  const [proforma, setProforma] = useState([]);
  const history = useHistory();
  const [selectedStatus, setSelectedStatus] = useState(["All"]);
  const [deleteDocument, setDeleteDocument] = useState(false);
  const [poidToDelete, setPoIdToDelete] = useState(0);
  const [querystring, setQuerystring] = useState("");
  const [validemail, setValidemail] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [downloadingProformaId, setDownloadingProformaId] = useState(null);

  const [menuStates, setMenuStates] = useState(
    Array(proforma.length).fill(false),
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Proforma-List-Add-Update").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const toggleMenu = (index) => {
    setMenuStates((prevMenuStates) => {
      if (prevMenuStates[index]) {
        return Array(prevMenuStates.length).fill(false);
      }
      const newMenuStates = Array(prevMenuStates.length).fill(false);
      newMenuStates[index] = !prevMenuStates[index];
      return newMenuStates;
    });
  };

  useEffect(() => {
    getProforma();
  }, [querystring]);

  const [sortedProforma, setSortedProforma] = useState(proforma);

  const getProforma = async () => {
    var result = await GetProforma(querystring);
    setProforma(result);
    setSortedProforma(result);
  };

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    const formattedDate = new Date(dateString).toLocaleDateString(
      "en-GB",
      options,
    );
    return formattedDate;
  };

  const [sortOption, setSortOption] = useState("Date");
  const [sortOrder, setSortOrder] = useState("asc");

  const handleSelectChange = (event) => {
    const selectedOption = event.target.value;
    setSortOption(selectedOption);
    setSortOrder(
      selectedOption === sortOption
        ? sortOrder === "asc"
          ? "desc"
          : "asc"
        : "asc",
    );
    sortData();
  };

  const handleSortClick = () => {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    sortData();
  };

  const sortData = () => {
    setSortedProforma(
      [...proforma].sort((a, b) => {
        switch (sortOption) {
          case "Date":
            return sortOrder === "asc"
              ? new Date(a.date) - new Date(b.date)
              : new Date(b.date) - new Date(a.date);
          case "Request ID":
            return sortOrder === "asc"
              ? a.requestId - b.requestId
              : b.requestId - a.requestId;
          case "Project ID":
            return sortOrder === "asc"
              ? a.projectId - b.projectId
              : b.projectId - a.projectId;
          case "Project Name":
            return sortOrder === "asc"
              ? a.projectName.localeCompare(b.projectName)
              : b.projectName.localeCompare(a.projectName);
          case "Status":
            return sortOrder === "asc"
              ? a.status.localeCompare(b.status)
              : b.status.localeCompare(a.status);
          default:
            return 0;
        }
      }),
    );
  };

  const checkEmailValidation = (e) => {
    // const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const emails = e.target.value;
    if (!emailPattern.test(emails) && emails.trim() !== "") {
      setValidemail(true);
    } else {
      setValidemail(false);
    }
  };

  const [typeEmail, setTypeEmail] = useState("");
  const handleEmailChange = (event) => {
    setTypeEmail(event.target.value.toLowerCase().trim());
    checkEmailValidation(event);
  };

  const handleSend = async (poId) => {
    let data = {
      PerformanceVoucherId: poId,
      ClientEmail: typeEmail,
      link: "",
    };
    var result = await SendPO(data);
    if (result.status === true) {
      setShowLoader(false);
      setEmailPopup(false);
      setTypeEmail("");
    }
    getProforma();
  };

  const handleMakeInvoice = async (poId) => {
    var result = await MakeInvoice(poId);
    getProforma();
  };

  const handleDelete = (poId) => {
    setPoIdToDelete(poId);
    setDeleteDocument(true);
  };

  const handleDeleteDocumentFun = async () => {
    setDeleteDocument(false);
    if (poidToDelete) {
      console.log("Inside");
      await DeletePO(poidToDelete);
      getProforma();
      setPoIdToDelete(0);
    }
  };

  const [filterPopup, setFilterPopup] = useState(false);

  // const handleCheckboxChange = (status) => {
  //   setSelectedStatus((prevSelectedStatus) =>
  //     prevSelectedStatus.includes(status)
  //       ? prevSelectedStatus.filter((s) => s !== status)
  //       : [...prevSelectedStatus, status]
  //   );

  //   const filteredProforma = sortedProforma.filter(
  //     (po) => selectedStatus.length === 0 || selectedStatus.includes(po.status)
  //   );
  //   setSortedProforma(filteredProforma);
  // };

  // Set default state to "All" selected

  const handleCheckboxChange = (status) => {
    if (status === "All") {
      // Toggle "All" selection and clear other filters if "All" is selected
      setSelectedStatus((prevSelectedStatus) =>
        prevSelectedStatus.includes("All") ? [] : ["All"],
      );
      setSortedProforma(proforma); // Show all records when "All" is selected
    } else {
      // Toggle individual status selection
      const newSelectedStatus = selectedStatus.includes(status)
        ? selectedStatus.filter((s) => s !== status)
        : [...selectedStatus.filter((s) => s !== "All"), status];

      setSelectedStatus(newSelectedStatus);

      // Filter records based on individual selections or show all if no filters are selected
      if (newSelectedStatus.length > 0) {
        const filteredProforma = proforma.filter((po) =>
          newSelectedStatus.includes(po.status),
        );
        setSortedProforma(filteredProforma);
      } else {
        setSortedProforma(proforma); // Show all records if no specific filters are selected
      }
    }
  };

  const handleEditPO = (poId) => {
    GetPOById(poId).then((result) => {
      let data = {
        action: "edit",
        project: {
          projectId: result[0]?.projectId,
          projectName: result[0]?.projectname,
        },
        client: {
          clientId: result[0]?.clientId,
          clientName: result[0]?.clientname,
        },
        poResult: result,
      };
      history.push("/request-po", data);
    });
  };

  const downloadPDF = async (performaId, proformaCode) => {
    setDownloadingProformaId(performaId);
    try {
      const response =
        await grapesTemplateApi.renderDefaultProformaPdf(performaId);
      if (!response.headers["content-type"]?.includes("application/pdf")) {
        const payload = JSON.parse(await response.data.text());
        throw new Error(
          payload?.message ||
            "Unable to generate the default Proforma template PDF.",
        );
      }

      const objectUrl = URL.createObjectURL(response.data);
      const downloadLink = document.createElement("a");
      const contentDisposition = response.headers["content-disposition"] || "";
      const fileNameMatch = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i,
      );
      downloadLink.href = objectUrl;
      downloadLink.download =
        fileNameMatch?.[1]?.replace(/["']/g, "") ||
        `Proforma-${proformaCode}.pdf`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      let message =
        error?.message ||
        "Unable to download the default Proforma template PDF.";
      if (error?.response?.data instanceof Blob) {
        try {
          const payload = JSON.parse(await error.response.data.text());
          message = payload?.message || message;
        } catch {
          // Keep the fallback message when the response is not JSON.
        }
      }
      window.alert(message);
    } finally {
      setDownloadingProformaId(null);
    }
  };

  const [inputTextArray, setInputTextArray] = useState(
    Array(sortedProforma.length).fill(""),
  );

  const handleChange = (event, index) => {
    const newInputTextArray = [...inputTextArray];
    newInputTextArray[index] = event.target.value;
    setInputTextArray(newInputTextArray);
  };

  const handleBlur = async (poId, index) => {
    const currentInputText = inputTextArray[index].trim();
    if (currentInputText !== "") {
      var data = {
        performaVoucherId: poId,
        clientPoNumber: currentInputText,
      };
      var result = await addClientPO(data);
    }
  };

  // for pagination start
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  // for pagination end

  useEffect(() => {
    setTotalPages(Math.ceil(sortedProforma.length / perPage));
  }, [sortedProforma, perPage]);

  return (
    <>
      {downloadingProformaId && (
        <div
          className="document-download-loader"
          role="status"
          aria-live="polite"
        >
          <Loader />
          <p>Preparing PDF download...</p>
        </div>
      )}
      <Header
        setQuery={setQuerystring}
        leftComponent={
          <div
            style={{
              color: "#333333",
              fontSize: "16px",
              lineHeight: "27px",
              fontWeight: "bold",
            }}
          >
            <div style={{ display: "flex", gap: "30px", alignItems: "center" }}>
              <p className="mb-0">
                {/* Projects */}
                {t("Projects")}
              </p>
              <p
                className="mb-0"
                style={{
                  background: "white",
                  fontWeight: "bold",
                  padding: "0 20px",
                  fontSize: "14px",
                  borderRadius: "5px",
                }}
              >
                {/* Proforma */}
                {t("Proforma")}
              </p>
            </div>
          </div>
        }
      />
      <div className="header-content ps-5 p-4">
        <div
          style={{
            display: "flex",
            gap: "10px",
            fontSize: "14px",
            alignItems: "center",
          }}
        >
          <p style={{ margin: "0", color: "#707070" }}>
            {/* Sort By */}
            {t("Sort By")}
          </p>
          {sortOrder === "asc" ? (
            <ArrowUpwardRoundedIcon
              style={{ cursor: "pointer", fontSize: "18px", color: "black" }}
              onClick={handleSortClick}
            />
          ) : (
            <ArrowDownwardIcon
              style={{ cursor: "pointer", fontSize: "18px", color: "black" }}
              onClick={handleSortClick}
            />
          )}
          <select
            value={sortOption}
            onChange={handleSelectChange}
            style={{ border: "none", background: "none" }}
          >
            <option value="Date">
              {/* Date */}
              {t("Date")}
            </option>
            <option value="Request ID">
              {/* Request ID */}
              {t("Request ID")}
            </option>
            <option value="Project ID">
              {/* Project ID */}
              {t("Project ID")}
            </option>
            <option value="Project Name">
              {/* Project Name */}
              {t("Project Name")}
            </option>
            <option value="Status">
              {/* Status */}
              {t("Status")}
            </option>
          </select>
        </div>
        <div
          className="hide-in-mobile"
          style={{
            display: "flex",
            gap: "10px",
            fontSize: "14px",
            position: "relative",
            cursor: "pointer",
          }}
          onClick={() => {
            setFilterPopup(!filterPopup);
          }}
        >
          <p style={{ margin: "0" }}>
            {/* Filters */}
            {t("Filters ")}
          </p>
          <TuneRoundedIcon />
          {selectedStatus.join(", ")}
        </div>
        {filterPopup && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              fontSize: "14px",
              width: "200px",
              padding: "20px",
              gap: "10px",
              borderRadius: "5px",
              boxShadow: "-3px 3px 6px 0px #bdbdbd",
              position: "absolute",
              right: "32vw",
              zIndex: "1",
              background: "white",
              top: "169px",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                handleCheckboxChange("All");
              }}
            >
              <Checkbox
                icon={<CircleOutlinedIcon fontSize="small" />}
                checkedIcon={<CircleIcon fontSize="small" />}
                checked={selectedStatus.includes("All")}
              />
              <p style={{ margin: "0" }}>
                {/* All */}
                {t("All")}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                handleCheckboxChange("Sent");
              }}
            >
              <Checkbox
                icon={<CircleOutlinedIcon fontSize="small" />}
                checkedIcon={<CircleIcon fontSize="small" />}
                checked={selectedStatus.includes("Sent")}
              />
              <p style={{ margin: "0" }}>
                {/* Sent */}
                {t("Sent")}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                handleCheckboxChange("Not Sent");
              }}
            >
              <Checkbox
                icon={<CircleOutlinedIcon fontSize="small" />}
                checkedIcon={<CircleIcon fontSize="small" />}
                checked={selectedStatus.includes("Not Sent")}
              />
              <p style={{ margin: "0" }}>
                {/* Not Sent */}
                {t("Not Sent")}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                handleCheckboxChange("Invoiced");
              }}
            >
              <Checkbox
                icon={<CircleOutlinedIcon fontSize="small" />}
                checkedIcon={<CircleIcon fontSize="small" />}
                checked={selectedStatus.includes("Invoiced")}
              />
              <p style={{ margin: "0" }}>
                {/* Invoiced */}
                {t("Invoiced")}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                handleCheckboxChange("Not Invoiced");
              }}
            >
              <Checkbox
                icon={<CircleOutlinedIcon fontSize="small" />}
                checkedIcon={<CircleIcon fontSize="small" />}
                checked={selectedStatus.includes("Not Invoiced")}
              />
              <p style={{ margin: "0" }}>
                {/* Not Invoiced */}
                {t("Not Invoiced")}
              </p>
            </div>
          </div>
        )}
        <div
          onClick={() => {
            var data = {
              action: "add",
            };
            history.push("/request-po", data);
          }}
        >
          <p
            className="m-0 task-modal-cancel-btn1-pop me-3"
            style={{ fontSize: "16px" }}
            onClick={() => {
              setEmailPopup(true);
            }}
          >
            <MonetizationOnOutlinedIcon style={{ marginRight: "10px" }} />
            {/* Add New */}
            {t("Add New")}
          </p>
        </div>
      </div>

      <div
        className="ascTableWrapper"
        style={{
          height: "auto",
          margin: "0 40px",
          padding: "12px",
          background: "white",
        }}
      >
        <table className="table width-in-mobile">
          <thead>
            <tr
              className="accordian-summary-heading-div"
              style={{ color: "#7e7e7e" }}
            >
              <th className="mobile-reques">
                {/* Request ID */}
                {t("Request ID")}
              </th>
              <th className="mobile-date">
                {/* Date */}
                {t("Date")}
              </th>
              <th className="mobile-project">
                {/* Project ID */}
                {t("Project ID")}
              </th>
              <th className="mobile-projectname">
                {/* Project Name */}
                {t("Project Name")}
              </th>
              <th className="mobile-amount">
                {/* Total Amount */}
                {t("TOTAL AMOUNT")}
              </th>
              <th className="mobile-client">
                {/* Client PO no. */}
                {t("Clinet PO no.")}
              </th>
              <th>
                {/* Status */}
                {t("Status")}
              </th>
            </tr>
          </thead>
          <tbody>
            <React.Fragment>
              {sortedProforma
                ?.slice(currentPage * perPage, (currentPage + 1) * perPage)
                .map((po, index) =>
                  po.status && po.status.toLowerCase() !== "deleted" ? (
                    <tr
                      className="accordian-summary-heading-div"
                      style={{ position: "relative", verticalAlign: "middle" }}
                    >
                      <td
                        className="performa-id d-flex gap-2"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          handleEditPO(po.performaVoucherId);
                        }}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                      >
                        {po.requestId}{" "}
                        {hoveredIndex === index && (
                          // <PictureAsPdfIcon
                          //   onClick={(e) => {
                          //     e.stopPropagation();
                          //     console.log("clicked");
                          //     downloadPDF(po.performaVoucherId, po.requestId);
                          //   }}
                          // />

                          <img
                            className="invoIcon"
                            src={pdfIcon}
                            alt="Download Proforma PDF"
                            style={{
                              cursor:
                                downloadingProformaId === po.performaVoucherId
                                  ? "wait"
                                  : "pointer",
                              opacity:
                                downloadingProformaId === po.performaVoucherId
                                  ? 0.55
                                  : 1,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (
                                downloadingProformaId !== po.performaVoucherId
                              ) {
                                downloadPDF(po.performaVoucherId, po.requestId);
                              }
                            }}
                          />
                        )}
                      </td>
                      <td className="mobile-po-date">{formatDate(po.date)}</td>
                      <td className="mobile-po-project-id">{po.projectId}</td>
                      <td className="mobile-po-project-name">
                        {po.projectName}
                      </td>
                      <td className="mobile-po-total-amount">
                        {/* {po.totalAmount} */}
                        &euro; {po.totalAmount.toFixed(2)}
                      </td>
                      {po.clientPO != null && po.clientPO.length > 0 ? (
                        <td>{po.clientPO}</td>
                      ) : (
                        <td>
                          <input
                            className="mobile-width-size"
                            style={{ border: "none", background: "#FAFAFA" }}
                            type="text"
                            value={inputTextArray[index]}
                            onChange={(e) => handleChange(e, index)}
                            onKeyDown={() => {
                              handleBlur(po.performaVoucherId, index);
                            }}
                            onBlur={() => {
                              handleBlur(po.performaVoucherId, index);
                            }}
                          />
                        </td>
                      )}
                      <td
                        className={
                          po.status && po.status.toLowerCase() === "not sent"
                            ? "label-orange"
                            : ""
                        }
                      >
                        {po.status}
                      </td>
                      <td
                        className="pointer"
                        onClick={() => {
                          toggleMenu(index);
                          setEmailPopup(false);
                        }}
                      >
                        <MoreVertRoundedIcon />
                      </td>
                      {menuStates[index] && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            fontSize: "14px",
                            width: "200px",
                            padding: "20px",
                            gap: "10px",
                            borderRadius: "5px",
                            boxShadow: "-3px 3px 6px 0px #bdbdbd",
                            position: "absolute",
                            right: "0px",
                            zIndex: "1",
                            background: "white",
                            top: "37px",
                          }}
                        >
                          {po.status !== "Sent" && (
                            <div
                              style={{
                                display: "flex",
                                gap: "5px",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setEmailPopup(!emailPopup);
                                setTypeEmail(po.cleintEmailAddress);

                                localStorage.setItem(
                                  "QuoteNoForPrint",
                                  po.requestId,
                                );
                                localStorage.setItem(
                                  "clientNameForPrint",
                                  po.projectName ?? "",
                                );
                              }}
                            >
                              <SendOutlinedIcon />
                              <p style={{ margin: "0" }}>
                                {/* Send */}
                                {t("Send")}
                              </p>
                            </div>
                          )}
                          {emailPopup && (
                            <div className="email-popup-proforma">
                              <img
                                src={Xcircle}
                                alt="close popup"
                                className="ms-auto pointer"
                                style={{ width: "18px" }}
                                onClick={() => {
                                  setEmailPopup(false);
                                  // setShowLoader(false);
                                }}
                              />
                              <TextField
                                id="outlined-basic"
                                label="Client Email"
                                variant="outlined"
                                style={{
                                  color: "#5B5B5B",
                                  borderColor: "#5B5B5B",
                                  borderRadius: "8px",
                                  width: "100%",
                                }}
                                // value={po.cleintEmailAddress}
                                value={typeEmail}
                                onChange={handleEmailChange}
                              />
                              <div
                                className={
                                  validemail ? "ps-1 py-2" : "invisible py-2"
                                }
                                style={{ color: "red", fontSize: "14px" }}
                              >
                                <i className="pe-1 bi bi-exclamation-circle"></i>
                                Email is invalid
                                {/* {t("Email is invalid")} */}
                              </div>
                              <p
                                className="m-0 task-modal-cancel-btn1-pop me-3"
                                style={{
                                  background: "#D2DCE9",
                                  color: "#00246A",
                                }}
                                onClick={async () => {
                                  if (validemail || typeEmail === "") return;

                                  setShowLoader(true);
                                  await handleSend(po.performaVoucherId);
                                }}
                              >
                                {/* Send */}
                                {t("Send")}
                                {showLoader && (
                                  <span className="ms-2">
                                    <Spinner animation="border" size="sm" />
                                  </span>
                                )}
                              </p>
                            </div>
                          )}

                          <div
                            style={{
                              // display: "flex",
                              display: "none",
                              gap: "5px",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleMakeInvoice(po.performaVoucherId);
                            }}
                          >
                            <MonetizationOnOutlined />
                            <p style={{ margin: "0" }}>
                              {/* Make Invoice */}
                              {t("Make Invoice ")}
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              gap: "5px",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleDelete(po.performaVoucherId);
                            }}
                          >
                            <DeleteIcon />
                            <p style={{ margin: "0" }}>
                              {/* Delete */}
                              {t("Delete ")}
                            </p>
                          </div>
                        </div>
                      )}
                    </tr>
                  ) : (
                    <tr
                      className="accordian-summary-heading-div color-gray"
                      style={{ position: "relative" }}
                    >
                      <td className="" style={{ cursor: "pointer" }}>
                        {po.requestId}
                      </td>
                      <td className="mobile-po-date">{formatDate(po.date)}</td>
                      <td className="mobile-po-project-id">{po.projectId}</td>
                      <td className="mobile-po-project-name">
                        {po.projectName}
                      </td>
                      <td className="mobile-po-total-amount">
                        {po.totalAmount}
                      </td>
                      <td className="mobile-po-clint-po">{po.clientPO}</td>
                      <td>{po.status}</td>
                      <td className="">
                        <MoreVertRoundedIcon />
                      </td>
                    </tr>
                  ),
                )}
            </React.Fragment>
            {sortedProforma?.length === 0 && (
              <div className="noDataDisplay text-cente-r p-2">
                No data to display!
              </div>
            )}
          </tbody>
        </table>

        <Pagination
          perPage={perPage}
          setPerPage={setPerPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
        />
      </div>

      {deleteDocument && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteDocumentFun}
          show={deleteDocument}
          onHide={() => setDeleteDocument(false)}
          // title1={"This data will be removed from the system"}
          // title2={"and cannot be undone."}
          // title3={"Do you want to proceed?"}
          // no={"No"}
          // yes={"Yes"}
          title1={t("This data will be removed from the system")}
          title2={t("and cannot be undone.")}
          title3={t("Do you want to proceed?")}
          no={t("No")}
          yes={t("Yes")}
        />
      )}
    </>
  );
};

export default Proforma;
